import { useMergeRefs } from "@floating-ui/react"
import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
  HTMLProps,
  MutableRefObject,
} from "react"
import {
  cloneElement,
  forwardRef,
  isValidElement,
} from "react"
import styles from "./LargeMenuModalItem.module.scss"

export type Props = ComponentPropsWithoutRef<"div"> & {
  asChild?: boolean;
}

export const LargeMenuModalItemSubtext = forwardRef<HTMLDivElement, Props>(
  function LargeMenuModalItemSubtext(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      children,
      asChild = false,
      ...htmlDivProps
    } = props
    const className = classNames(
      props.className,
      styles.largeMenuModalItemSubtext,
    )

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const childrenRef: MutableRefObject<any> = (children as any)?.ref
    const refWithChildrenRef = useMergeRefs([
      propRef,
      childrenRef,
    ])

    // `asChild` allows the user to pass an element as the subtext
    if (asChild && isValidElement(children)) {
      return cloneElement(
        children,
        {
          ref: refWithChildrenRef,
          ...htmlDivProps,
          ...children.props,
          className,
        } as HTMLProps<HTMLElement>,
      )
    }

    return (
      <div
        {...htmlDivProps}
        className={className}
        ref={propRef}
      >
        {children}
      </div>
    )
  },
)
